module.exports = __webpack_public_path__ + "img/rectoplus_logo_white_font.de28bc18.png";